module.exports = __webpack_public_path__ + "img/1.d402e1ae.jpg";